module.exports = __webpack_public_path__ + "static/media/Pyroar_gaussian2.fce5db66.png";